module.exports = __webpack_public_path__ + "img/Musca.b68464d9.png";